import LifecareStudioField from './LifecareStudioField';
import LifecareStudioSectionCard from './LifecareStudioSectionCard';
import LifecareStudioSubsection from './LifecareStudioSubsection';
import { inlineButtonClasses } from './lifecareStudioClasses';
import { planFieldPaths } from '../../utils/lifecarePlanUtils';
import useLifecareStudioFutureCareNeeds from '../../hooks/useLifecareStudioFutureCareNeeds';

const LifecareStudioFutureCareNeedsSection = ({
  subsections,
  subsectionSubtotals,
  onAddSubsection,
  onRemoveSubsection,
  onAddRow,
  onRemoveRow,
  onMoveRow,
  onRowFieldChange,
}) => {
  const { hasSubsections, enrichedSubsections } = useLifecareStudioFutureCareNeeds({
    subsections,
    subsectionSubtotals,
  });

  return (
    <LifecareStudioSectionCard
      actions={
        <button type="button" className={inlineButtonClasses} onClick={onAddSubsection}>
          <i className="fa fa-plus" />
          <span>Add subsection</span>
        </button>
      }
    >
      <LifecareStudioField name={planFieldPaths.futureCareNeedsTitle} placeholder="Heading" />
      <div className="mt-4">
        {!hasSubsections ? (
          <p className="text-sm text-subtle italic">
            No subsections yet. Use "Add subsection" to start.
          </p>
        ) : (
          enrichedSubsections.map(({ subsection, index, subtotal, moveTargets }) => (
            <LifecareStudioSubsection
              key={index}
              subsectionIndex={index}
              subsection={subsection}
              subtotal={subtotal}
              moveTargets={moveTargets}
              onRemoveSubsection={onRemoveSubsection}
              onAddRow={onAddRow}
              onRemoveRow={onRemoveRow}
              onMoveRow={onMoveRow}
              onRowFieldChange={onRowFieldChange}
            />
          ))
        )}
      </div>
    </LifecareStudioSectionCard>
  );
};

export default LifecareStudioFutureCareNeedsSection;
